import { Observable } from 'rxjs';
import { UserDataSource } from '@/modules/users/users.datasource';
import { Component, OnInit } from '@angular/core';
import { UsersFragment, UsersGQL } from "@/core/graphql/graphql";
import { USER_COLUMNS } from '@/modules/users/users.const';
import { CosmosDialogService, CosmosDialogStyle } from "@/core/services/cosmos-dialog.service";
import { UserDetailsModalComponent } from "@/modules/users/components/user-details-modal/user-details-modal.component";
import { UserDialog } from "@/modules/users/components/user-details-modal/user-dialog.model";
import { filter, first } from "rxjs/operators";

@Component({
  selector: 'cosmos-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  public _loading$: Observable<boolean>;
  public _downloadingCSV$: Observable<boolean>;
  public readonly _dataSource: UserDataSource;
  public readonly _columns = USER_COLUMNS;

  public constructor(
    private readonly _usersGql: UsersGQL,
    private readonly _dialog: CosmosDialogService,
  ) {
    this._dataSource = new UserDataSource(_usersGql);
    this._loading$ = this._dataSource._loading$;
    this._downloadingCSV$ = this._dataSource._downloadingCSVSubject.asObservable();
  }

  public ngOnInit(): void {
    this._dataSource.loadData(null);
  }

  public onTableRowClick(data: UsersFragment): void {
    const dialogRef = this._dialog.open<UserDetailsModalComponent, { userId: number }, UserDialog>(
      UserDetailsModalComponent,
      {
        data: {
          userId: data.id,
        },
        style: CosmosDialogStyle.Dark,
      });

    dialogRef.afterClosed().pipe(
      first(),
      filter(data => !!data?.refreshData),
    ).subscribe(_ => this._dataSource.loadData(null));
  }

  public exportAll(): void {
    this._dataSource.getUnfilteredUserList();
  }

  public exportFiltered(): void {
    this._dataSource.getFilteredUserList();
  }
}
